import React from "react";
import { connect } from "react-redux";
import mapStateToProps from "reducers/actions/stateToProps";
import mapDispatchToProps from "reducers/actions/dispatchProps";
import ReceiptManager from "components/receipt/ReceiptManager";
import { AccountHandler } from "chits-data/dist";

class Statements extends React.Component {
  constructor(props) {
    super(props);
    this._accountHandler = new AccountHandler();
  }

  // componentDidMount = () => {
  //   //TODO: If this page accessed without account set; redirect to /info
  //   let ac = this._accountHandler.getActiveAccount();
  //   // asynchronously load account information to props
  //   this._accountHandler.getAccountCached(ac).then((account) => {
  //     if (account) this.props.setCurrentAccount(account);
  //   });
  // };

  render() {
    let { wallet } = this.props;
    return (
      <div className="content-fluid">
        <div className="row">
          <div className={"col-md-9 mx-auto"}>
            <div className="card">
              <div
                className="card-header"
                style={{
                  paddingLeft: "1em",
                  paddingRight: "1em",
                  paddingTop: "1em",
                  textAlign: "center",
                }}
              >
                <h4 className="card-title">Attachments & Receipts</h4>
                <p
                  className="card-category"
                  style={{ color: "#9C27B0", fontWeight: "500" }}
                >
                  {wallet.current._id === "default" ? "" : wallet.current.name}
                </p>
              </div>
              <div className="card-body" style={{ padding: "4px" }}>
                <div
                  className="card"
                  style={{ marginTop: "1em", marginBottom: "1em" }}
                >
                  <div
                    className="card-header"
                    style={{ padding: "8px 4px 0px 14px", fontSize: "smaller" }}
                  >
                    <span>
                      Here you can attach receipts to this chit account.
                    </span>
                  </div>
                  <div
                    className="card-body"
                    style={{ padding: "4px 2px 0px 2px" }}
                  >
                    <ReceiptManager
                      display={true}
                      entity={"ac"}
                      entityId={this.props.wallet.current._id}
                      onChange={() => {}}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Statements);
